import { REGISTRATION_PAGE_ID, PRIMARY_RED, PRIMARY_RGBA } from "./escapeRoomEditorConstants";
import { defaultElement } from "./escapeRoomElementFactory";

export function getDefaultRegistrationPage() {
	const el = (html, x, y, w, h, style = {}, locked = true) => ({
		...defaultElement("text"),
		x, y, width: w, height: h,
		content: { html: `<p>${html}</p>` },
		style: { fontFamily: "Helvetica, Arial, sans-serif", fontSize: 18, color: PRIMARY_RED, fontWeight: "bold", ...style },
		registrationLocked: locked,
	});
	const shape = (type, x, y, w, h, content = {}, locked = true) => ({
		...defaultElement(`shape-${type}`),
		x, y, width: w, height: h,
		content: { shapeType: type, fillColor: "rgba(125, 0, 252, 0.15)", strokeColor: PRIMARY_RGBA, strokeWidth: 2, borderRadius: 0, ...content },
		registrationLocked: locked,
	});
	const img = (x, y, w, h, role, url = "") => ({
		...defaultElement("image"),
		x, y, width: w, height: h,
		content: { url, alt: role === "logo" ? "Logo" : "" },
		registrationLocked: false,
		registrationRole: role,
	});

	return {
		pageId: REGISTRATION_PAGE_ID,
		order: 0,
		name: "Registro",
		registrationDesign: {
			backgroundImageUrl: "",
			backgroundColor: "#ffffff",
			logoUrl: "",
			primaryColor: PRIMARY_RED,
		},
		elements: [
			img(430, 8, 100, 100, "logo"),
			el("Haz una foto de equipo", 25, 55, 220, 28, { fontSize: 22, backgroundColor: "rgba(255,255,255,0.7)", color: PRIMARY_RED }, true),
			shape("circle", 50, 88, 140, 140, { fillColor: "rgba(255,255,255,0.85)", strokeColor: PRIMARY_RGBA, strokeWidth: 2 }, true),
			el("📷", 95, 130, 50, 50, { fontSize: 40, textAlign: "center" }, true),
			el("Añade los participantes", 480, 55, 250, 28, { fontSize: 22 }, true),
			shape("square", 480, 88, 360, 38, { fillColor: "transparent", strokeColor: PRIMARY_RGBA, strokeWidth: 2 }, true),
			el("Escribe nombre y apellido", 495, 96, 280, 22, { fontSize: 14, fontWeight: "normal", color: "#999" }, true),
			shape("circle", 830, 93, 38, 38, { fillColor: PRIMARY_RGBA }, true),
			el("+", 838, 88, 22, 38, { fontSize: 28, color: "#fff", textAlign: "center" }, true),
			el("Participantes del grupo", 480, 138, 250, 24, { fontSize: 20 }, true),
			el("Debe añadir algún participante al grupo", 480, 165, 350, 22, { fontSize: 14, fontWeight: "normal" }, true),
			el("Elige tu número de mesa asignado", 25, 248, 320, 26, { fontSize: 20 }, true),
			el("Tu mesa tiene un número asignado, debes seleccionar ese número para el registro", 25, 276, 400, 36, { fontSize: 12, fontWeight: "normal" }, true),
			shape("square", 25, 315, 260, 38, { fillColor: "transparent", strokeColor: PRIMARY_RGBA, strokeWidth: 2 }, true),
			el("Selecciona una mesa", 40, 322, 230, 24, { fontSize: 14, fontWeight: "normal", color: "#999" }, true),
			el("Pon un nombre a tu equipo", 25, 368, 260, 26, { fontSize: 20 }, true),
			el("(Máximo 15 caracteres)", 25, 396, 180, 20, { fontSize: 12, fontWeight: "normal" }, true),
			shape("square", 25, 420, 260, 38, { fillColor: "transparent", strokeColor: PRIMARY_RGBA, strokeWidth: 2 }, true),
			el("Escribe el nombre", 40, 427, 230, 24, { fontSize: 14, fontWeight: "normal", color: "#999" }, true),
			el("Siguiente", 700, 455, 90, 28, { fontSize: 22 }, true),
			shape("circle", 800, 435, 70, 70, { fillColor: PRIMARY_RGBA }, true),
			el("→", 818, 442, 35, 36, { fontSize: 32, color: "#fff", textAlign: "center" }, true),
		],
	};
}
